import "./banner/Banner.css";
import Banner from "./banner/Banner";
import {
  faBars,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popular_Product from "./popular_product/Popular_Product";
import "./Home.css";
import Explore_By_Category from "./explore_by_category/Explore_By_Category";
import Offers_Slider from "./offers_slider/Offers_Slider";
import Common_Product_Swiper from "../common_components/common_product_swiper/Common_Product_Swiper";
import Green_Btn from "../common_components/common_btn/green_btn/Green_Btn";
import { useEffect, useState } from "react";
import Banner_Btn_Component from "./banner_btn_component/Banner_Btn_Component";
import Offer_Banner from "./offer_banner/Offer_Banner";
import New_In_Store from "./new_in_store/New_In_Store";
import Offer_Products from "./offer_products/Offer_Products";
import { useNavigate } from "react-router-dom";
import {
  getAddBanner,
  getCoupons,
  getOfferProduct,
} from "../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";
import { getGroupByProduct } from "../../features/products/productsSlice";
import Shop_brands from "./shop_brands/Shop_brands";
import Best_Sellers from "./best_Sellers/Best_Sellers";
import { AllBrand, getAllCategories, getAllCategoriesBest } from "../../features/master/masterSlice";

function Home() {
  const dispatch = useDispatch();
  const [categoryId, setCategoryId] = useState();

  const coupons = useSelector((state) => state.home.addCoupons);

  useEffect(() => {
    dispatch(getCoupons(100));
  }, []);

  useEffect(() => {
    dispatch(getGroupByProduct({}));
  }, [dispatch]);

  const addBanners = useSelector((state) => state.home.addBanners);

  useEffect(() => {
    dispatch(getAddBanner());
  }, [dispatch]);

  const brand = useSelector((state) => state.master.all_brand);

  useEffect(() => {
    dispatch(AllBrand());
  }, [dispatch]);

  const categories = useSelector((state) => state.master.categories);
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

   const categoriesBest = useSelector((state) => state.master.categories_best);
  useEffect(() => {
    dispatch(getAllCategoriesBest());
  }, [dispatch]);

  


  return (
    <section className="Home">
      <div className="desktop_view">
        <div className="row me-0 ms-0 ">
          {/* <div className="col-xxl-2 col-xl-3 col-lg-3">
              <div className="row justify-content-between custom_row me-0 ms-0">
                <div className="col-lg-12 col-sm-6">
                  <div className="cat_div">
                    <button
                      className="cat_btn"
                      type="button"
                      onClick={() => {
                        navigate("/shop");
                      }}
                    >
                      <div className="left_side">
                        <div className="icon_holder">
                          <img
                            src="/assets/images/popular_products/bars.png"
                            className="bar_img"
                          />
                          <img
                            src="/assets/images/popular_products/bar_sort.png"
                            className="sort_bar_img"
                          />
                        </div>

                        <p className="btn_text">Categories</p>
                      </div>
                    </button>
                  </div>

                  <div className="popular_prod">
                    <Popular_Product />
                  </div>
                </div>
              </div>
            </div> */}
          {/* <div className="col-xxl-10 col-xl-9 col-lg-9"> */}
          <div className="col-12 p-0">
            <div className="body_container">
              <div className="container">
                <Banner />
              </div>
              <div className="container">
                <Explore_By_Category
                  categoryId={categoryId}
                  setCategoryId={setCategoryId}
                />
              </div>

              {coupons?.data?.length > 0 && (
                <div className="container">
                  <Offers_Slider coupons={coupons} />
                </div>
              )}

              {/* {categoryWiseProduct?.data?.slice(0, 3)?.map((val) => (
                  <div className="grocery_div" key={val.id}>
                    <Common_Product_Swiper
                      multiple="Multiple"
                      data={val}
                      background_color={val?.background_color}
                      button_color={val?.button_color}
                      headingText={val?.name}
                    />
                  </div>
                ))}
                {categoryWiseProduct?.data?.length > 3 && (
                  <div className="show_btn_div">
                    <Green_Btn
                      btn_name={
                        showMore
                          ? "Show Less Categories"
                          : "Show More Categories"
                      }
                      rightIcon={showMore ? faSortUp : faSortDown}
                      onClick={() => {
                        setShowMore(!showMore);
                      }}
                    />
                  </div>
                )} */}

              {/* {showMore && (
                  <>
                    {categoryWiseProduct?.data?.slice(3)?.map((val) => (
                      <div className="grocery_div" key={val.id}>
                        <Common_Product_Swiper
                          multiple="Multiple"
                          data={val}
                          background_color={val?.background_color}
                          button_color={val?.button_color}
                          headingText={val?.name}
                        />
                      </div>
                    ))}
                  </>
                )} */}

              {/* {addBanners?.[1]?.image ? (
                  <Banner_Btn_Component addBanners={addBanners} />
                ) : null} */}
              {/* <New_In_Store /> */}

              <div className="container">
                <Offer_Products />
              </div>
              {categoriesBest?.length > 0 && (
                <div className="container-fluid">
                  <Best_Sellers data={categoriesBest} />
                </div>
              )}

              {brand?.length > 0 && (
                <div className="container">
                  <Shop_brands data={brand} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
